/**
 * An enum of error types returned on a rejected transition.
 */
export const REJECT_TYPE = {
    /** Rejection type used when the transition is superseded by another */
    SUPERSEDED: 2,
    /** General error resulting from a rejected resolve value. */
    ERROR: 6
}
